
import React, { useState } from "react";
import { MoreVert } from "@mui/icons-material";
import { Box, Menu, MenuItem, Typography, IconButton } from "@mui/material";
import { ResponsiveContainer } from "recharts";
import { toast } from "sonner";
import ShimmerLoader from './ShimmerLoader';
import { FileDownload } from "@mui/icons-material";
import { menuItemSx } from "../styles/GlobalStyles";
export const ChartContainer = ({ title, subtitle, chart, download, loading }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const handleDownload = (event) => {
        event.stopPropagation();
        toast.promise(download, {
            loading: "Downloading CSV File",
            success: "CSV File Downloaded Successfully",
            error: ({ error, message }) => error || "Error downloading CSV File",
        });
        setAnchorEl(null);
    };

    return (
        <Box
            sx={{
                p: 4,
                cursor: "pointer",
                height: '100%',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                bgcolor: 'white',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                    transform: 'scale(1.01)',
                    bgcolor: '#F5F5F5',
                }
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box>
                    <Typography variant="h6" color="text.primary">{title}</Typography>
                    <Typography sx={{ color: "#6A6A6A", fontSize: "0.8rem" }}>{subtitle}</Typography>
                </Box>
                <IconButton 
                    size="small" 
                    onClick={handleMenuClick} 
                    sx={{ color: 'text.secondary' }}
                >
                    <MoreVert />
                </IconButton>
            </Box>
            <ResponsiveContainer width="100%" height={400}>
                {loading ? <ShimmerLoader height="100%" /> : chart}
            </ResponsiveContainer>

            <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                onClick={(e) => e.stopPropagation()}
                PaperProps={{
                elevation: 2,
                sx: {
                    overflow: 'visible',
                    mt: 1.2, // Slightly reduced margin top
                    borderRadius: '8px', // Slightly tighter border radius
                    minWidth: '200px', // Reduced width
                    '& .MuiList-root': {
                    padding: '8px' // Slightly reduced padding
                    },
                    '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 16,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                    },
                },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleDownload} sx={menuItemSx} >
                    <FileDownload fontSize="small" sx={{ mr: 1 }} />
                    Download CSV
                </MenuItem>
            </Menu>
        </Box>
    );
};
